import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
    selector: 'app-transform-detail-json-viewer',
    templateUrl: './transform-detail-json-viewer.component.html',
    styleUrls: ['./transform-detail-json-viewer.component.css'],
    standalone: false
})
export class TransformDetailJsonViewerComponent implements OnInit {

  json: string;

  constructor(
    private clipboard: Clipboard,
    private snackBar: MatSnackBar
    ) {

    const state = history.state;
    //console.log(state.config);

    this.json = JSON.stringify(state.config, null, '\t');
  }

  ngOnInit(): void {
  }
  copyJson() {
    const state = history.state;
    this.clipboard.copy(JSON.stringify(state.config, null, 2));

    this.snackBar.open('JSON copied to clipboard', 'Close', {
      duration: 2000,
    });
  }
  async Export(): Promise<void>{
    const state = history.state; 
    const content = JSON.stringify(state.config, null, 2);

    const blob = new Blob([content], { type: "application/json;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = "exported_transformer.json";
    a.click();
    URL.revokeObjectURL(url);
  }
}
